import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ProjectService } from '../../../api/services/project.services';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BomCreateComponent } from '../bom-create/bom-create.component';
import { Bom } from '../../../api/models/bom';
import { ActivatedRoute } from '@angular/router';
import { MarketBannerService } from '../../market-banner/market-banner.service';
import { AnalyticsService } from '../../../api/services/analytics.service';

@Component({
  selector: 'app-bom-list',
  templateUrl: './bom-list.component.html',
  styleUrls: ['./bom-list.component.scss']
})
export class BomListComponent implements OnInit {

  items: Bom[] = [];
  itemsFiltered: Bom[] = [];
  itemsToShow: Bom[] = [];
  page = 1;
  pageSize = 20;
  loading = false;
  edit = false;
  bomSelected: Bom;
  errorMessages: string;
  bomFetchError: boolean = false;
  infoMsg = ['No BOMS found!'];

  backToSearch: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private projectService: ProjectService,
    private modalService: NgbModal,
    private analyticsService: AnalyticsService
  ) { }

  ngOnInit() {
    this.loading = true;
    this.activatedRoute
      .queryParams
      .subscribe(params => {
        let bomId: string = params['bomId'];
        this.backToSearch = params['backToSearch'];
        if (bomId) {
          this.projectService.getBom(bomId).subscribe(bom => {
            this.bomSelected = bom;
            this.edit = true;
            this.loading = false;
          }, error => {
            this.bomFetchError = true;
            this.loading = false;
          })
        }
      });
      this.fetchMasterBoms();
  }

  fetchMasterBoms() {
    this.projectService.getAllMasterBom().subscribe(boms => {
      this.loading = true;
      this.items = boms;
      this.itemsFiltered = boms;
      this.loadPage(1);
    });
  }

  openCreateBomModal() {
    const modalRef = this.modalService.open(BomCreateComponent, {
      backdrop: 'static',
      keyboard: false
    });

    modalRef.result.then((option: any) => {
      if (option === 'manually') {
        this.bomSelected = new Bom();
        this.edit = true;
      } else {
        if (option.id) {
          this.projectService.getBom(option.id).subscribe(bom => {
            this.bomSelected = bom;
            this.edit = true;
          });
        } else if (option.errorMessages && option.errorMessages.length > 0) {
          this.errorMessages = option.errorMessages.join(",<br/>");
        }
      }
    }).catch(() => { 
      //Empty catch block
    });
  }

  editBom(bom: Bom) {
    this.bomSelected = bom;
    this.edit = true;
  }

  backToListing() {
    this.edit = false;
    this.fetchMasterBoms();
  }

  loadPage(page) {
    this.page = page;
    const from = (page - 1) * this.pageSize;
    const to = from + this.pageSize;
    this.itemsToShow = this.itemsFiltered.slice(from, to);
    this.loading = false;
  }

  searchBom(value) {
    this.page = 1;
    if (value && value.trim().length > 0) {
      this.loading = true;
      const lowerCaseValue = value.trim().toLowerCase();
      this.itemsFiltered = this.items.filter(x => x.name.toLocaleLowerCase().includes(lowerCaseValue));
      this.sendDataToAnalytics(value);
    } else {
      this.itemsFiltered = this.items;
    }
    this.loadPage(this.page);
  }


  private sendDataToAnalytics(value: any) {
    this.analyticsService.trackMasterBomSearch(value);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/boms/bom-list/bom-list.component.ts